import type { ScoreMap } from "./types";

// Who won a round: the player whose score grew the most from the round's
// start to its end (null when nobody scored, a double crash in a duel).
export function roundWinner(startScore: ScoreMap, endScore: ScoreMap): string | null {
  let best: string | null = null;
  let bestGain = 0;
  for (const id of Object.keys(endScore)) {
    const gain = (endScore[id] || 0) - (startScore ? startScore[id] || 0 : 0);
    if (gain > bestGain) { bestGain = gain; best = id; }
  }
  return best;
}

// The winners of the rounds played so far, in order (core roundsData), for the
// duel dots (GameHud): a round nobody won leaves no dot.
export function roundWinners(roundsData: Array<{ startScore: ScoreMap; endScore: ScoreMap }>): string[] {
  return roundsData.map((r) => roundWinner(r.startScore, r.endScore)).filter((id): id is string => !!id);
}

// A winners list that may have missed rounds (an online reconnect only gets the
// score): pad it from the score, the order of the missing wins unknown.
export function padWinners(winners: string[], score: ScoreMap | null | undefined): string[] {
  if (!score) return winners;
  const out = winners.slice();
  const counted: Record<string, number> = {};
  for (const id of out) counted[id] = (counted[id] || 0) + 1;
  for (const id of Object.keys(score)) for (let i = counted[id] || 0; i < (score[id] || 0); i++) out.push(id);
  return out;
}
